import React, { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import {
  isImpersonating,
  getImpersonationData,
  stopImpersonation,
} from "../utils/impersonation";
import { FaUserSecret, FaTimes, FaShoppingBag, FaStore } from "react-icons/fa";

const ImpersonationBanner = () => {
  const location = useLocation();
  const [active, setActive] = useState(isImpersonating);
  const [data, setData] = useState(getImpersonationData);

  useEffect(() => {
    const updateState = () => {
      setActive(isImpersonating());
      setData(getImpersonationData());
    };

    window.addEventListener("impersonation-change", updateState);
    window.addEventListener("storage", updateState);
    return () => {
      window.removeEventListener("impersonation-change", updateState);
      window.removeEventListener("storage", updateState);
    };
  }, []);

  // Atualiza ao mudar de rota
  useEffect(() => {
    setActive(isImpersonating());
    setData(getImpersonationData());
  }, [location.pathname]);

  if (!active || !data) return null;

  return (
    <div
      id="admin-impersonation-banner"
      className="fixed top-0 left-0 right-0 z-[70] bg-gradient-to-r from-amber-600 via-orange-600 to-amber-700 text-white shadow-xl border-b border-amber-400/40 px-3 py-2 sm:px-4 sm:py-2 flex flex-wrap items-center justify-between gap-2 text-xs sm:text-sm animate-in fade-in duration-200"
    >
      <div className="flex items-center gap-2 sm:gap-3 flex-wrap">
        <span className="inline-flex items-center gap-1.5 bg-black/30 backdrop-blur-sm px-2.5 py-1 rounded-full text-[11px] font-bold uppercase tracking-wider border border-white/20">
          <FaUserSecret className="text-amber-300 text-sm animate-pulse" />
          Modo Simulação
        </span>

        <span className="font-medium text-white/95">
          Navegando como: <strong className="text-white underline decoration-amber-300 underline-offset-2">{data.athleteName || "Atleta"}</strong>
        </span>

        <span className="hidden md:inline-flex items-center text-[11px] bg-white/15 px-2 py-0.5 rounded text-amber-100 border border-white/10">
          🛡️ Logs desativados (acesso não contabilizado)
        </span>
      </div>

      <div className="flex items-center gap-2">
        <Link
          to="/ar/shop"
          className={`btn btn-xs rounded-md border-none font-semibold gap-1 ${
            location.pathname === "/ar/shop"
              ? "bg-white text-orange-900 shadow"
              : "bg-white/20 hover:bg-white/30 text-white"
          }`}
          title="Ver loja do atleta"
        >
          <FaStore />
          <span className="hidden sm:inline">Loja</span>
        </Link>

        <Link
          to="/ar/compras"
          className={`btn btn-xs rounded-md border-none font-semibold gap-1 ${
            location.pathname === "/ar/compras"
              ? "bg-white text-orange-900 shadow"
              : "bg-white/20 hover:bg-white/30 text-white"
          }`}
          title="Ver compras do atleta"
        >
          <FaShoppingBag />
          <span className="hidden sm:inline">Compras</span>
        </Link>

        <button
          type="button"
          onClick={stopImpersonation}
          className="btn btn-xs bg-black hover:bg-neutral-900 text-white font-bold border-none px-3 shadow hover:scale-105 active:scale-95 transition-all gap-1.5 ml-1"
          title="Encerrar simulação e voltar ao painel administrativo"
        >
          <FaTimes className="text-red-400" />
          <span>Sair da Simulação</span>
        </button>
      </div>
    </div>
  );
};

export default ImpersonationBanner;
